
import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { RestResponse } from  '../core/core/core.model'

import 'rxjs/operator/delay';
import 'rxjs/operator/mergeMap';
import 'rxjs/operator/switchMap';

import { LoginRest } from './login.rest'
import { ResetPasswordData, ResetFormRequest, WebToken } from './login.model';
import { ObjectToSelect } from '../core/shared/objectToSelect.model';
  
@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private loginResponse: RestResponse<string>;

  constructor(private http: Http, private loginRest: LoginRest) { }

    public login(user: string, password: string, customer: ObjectToSelect): Observable<WebToken>  {
        return this.loginRest.login(user, password, customer)
        .map((data:WebToken) => {
            localStorage.setItem('token', data.accessToken);
            localStorage.setItem('refreshToken', data.refreshToken);

            this.getUsersForMention().subscribe();

            return data;
        }); 
    };

    public logout(): Observable<string>{
        return this.loginRest.logout().map((data:string) =>
        {
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            return data;
        });
    }

    public changePassword(user: string, password: string, oldPassword: string): Observable<WebToken>  {
        return this.loginRest.changePassword(user, password, oldPassword)
        .map((data:WebToken) => {
            localStorage.setItem('token',data.accessToken)
            localStorage.setItem('refreshToken', data.refreshToken);
            return data;
        }); 
    };

    public sendPassword(email: string): Observable<boolean> {
        return this.http.post('api/password/preparetoreset', JSON.stringify({
        email: email
    }), {
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        })
        .map((res: Response) => {
            if (res.status < 200) {
                throw Error('Bad response status: ' + res.status);
            }
            this.loginResponse = res.json();
            if (this.loginResponse.isSuccess) {
                return true;
            } else {
                throw new Error(this.loginResponse.errorMessage);
            }
        }).catch((error) => {
            return Observable.throw(error);
        });
    };

    public resetPassword(resetPasswordData: ResetPasswordData) {
        return this.loginRest.resetPassword(resetPasswordData);
    }

    public sendResetFormUrl(url: string, username: string) {
        let request: ResetFormRequest = {
            url: url,
            username: username
        }
        return this.loginRest.sendResetFormUrl(request);
    }

    getCustomers(username: string) {
        return this.loginRest.getCustomers(username);
    }

    getUsersForMention() {
        return this.loginRest.getUsersForMention().map((users) => {
            localStorage.setItem('userMentions', JSON.stringify(users) || '[]');
            //console.log(users);
        }).catch((error) => {
            return Observable.of(null);
        });;
    }
}
